export default __webpack_public_path__ + "static/media/ThirdWave.7c3edb20.webp";